import { render, staticRenderFns } from "./Ihbarname893HacizForm.vue?vue&type=template&id=0da8f180&scoped=true"
import script from "./Ihbarname893HacizForm.vue?vue&type=script&lang=ts"
export * from "./Ihbarname893HacizForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da8f180",
  null
  
)

export default component.exports